import React from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
import Configurer from "../components/Configurer";
import WidgetComponents from "../components/widgets/WidgetComponents";
import { getUserWidgets } from "../variables/userWidgets";
import { checkTranslation } from "../utils/useful";
import { siteConfig } from "../variables/config";

// Import custom widgets
import ProcessStatusWidget from "../components/widgets/ProcessStatusWidget";
import ProcessChartWidget from "../components/widgets/ProcessChartWidget";

// Add custom widgets to WidgetComponents
WidgetComponents.ProcessStatusWidget = ProcessStatusWidget;
WidgetComponents.ProcessChartWidget = ProcessChartWidget;

class UserWidgetsPage extends React.Component {
    state = {
        modules: [],
        useFakeData: false, // Use fake data for visualization
    }

    componentDidMount() {
        this.loadWidgets()
    }

    componentDidUpdate(prevProps) {
        const currentUserType = siteConfig.testEnv && this.props.testUserType 
            ? this.props.testUserType 
            : this.props.user?.info?.userType

        const prevUserType = siteConfig.testEnv && prevProps.testUserType 
            ? prevProps.testUserType 
            : prevProps.user?.info?.userType

        if (currentUserType !== prevUserType) {
            this.loadWidgets()
        }
    }

    loadWidgets = () => {
        const userType = siteConfig.testEnv && this.props.testUserType 
            ? this.props.testUserType 
            : this.props.user?.info?.userType

        console.log('UserWidgetsPage - Loading widgets for userType:', userType, 'testEnv:', siteConfig.testEnv, 'testUserType:', this.props.testUserType)
        if (userType) {
            const widgets = getUserWidgets(userType)
            console.log('UserWidgetsPage - Widgets loaded:', widgets)
            this.setState({ modules: Object.values(widgets) })
        } else {
            console.log('UserWidgetsPage - No userType found')
            this.setState({ modules: [] })
        }
    }

    render() {
        const userType = siteConfig.testEnv && this.props.testUserType 
            ? this.props.testUserType 
            : this.props.user?.info?.userType
        const hasModules = this.state.modules && this.state.modules.length > 0
        
        if (!hasModules) {
            return (
                <div className="w-100 p-4 text-center">
                    <p style={{ color: '#999', fontSize: 14 }}>
                        {userType ? `Loading widgets for ${userType}...` : 'No user type selected'}
                    </p>
                </div>
            )
        }

        return (
            <div className={"row m-0 w-100"} style={{ padding: '20px' }}>
                <div className="col-12 pt-0 pb-4">
                    <div className="row m-0">
                        {this.state.modules?.map((prop, index) => {
                            let Component = WidgetComponents[prop.key]
                            if (Component) {
                                let variables = {
                                    permissionRoot: prop.permissionParent
                                }

                                return (
                                    <div className={"w-100 mb-3 p-1 col-12 col-md-" + (prop.col ?? "6")} key={index}>
                                        <div className="h-100 p-4 px-1 d-flex flex-column custom-scrollbar-widget" style={{
                                            backgroundColor: '#fff',
                                            borderRadius: 10,
                                            boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
                                            maxHeight: (prop.key === 'ProcessStatusWidget' || prop.key === 'ProcessChartWidget') ? 'auto' : '400px',
                                            minHeight: (prop.key === 'ProcessStatusWidget' || prop.key === 'ProcessChartWidget') ? 'auto' : '400px',
                                            overflow: 'visible'
                                        }}>
                                            <p className="text-start text-bold mt-2 mb-3 text-normal">
                                                {checkTranslation(prop.title)}
                                            </p>
                                            <Component
                                                widget={prop}
                                                dashboard={this.state.info}
                                                variables={variables}
                                                useFakeData={this.state.useFakeData}
                                            />
                                        </div>
                                    </div>
                                )
                            }
                            return null
                        })}
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UserWidgetsPage);

